/* eslint-disable default-case */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { Button } from "@material-ui/core";
import axios from "../../../axios";
import {
  NavigateLeftButtonIcon,
  NavigateRightButtonIcon,
} from "../../../libs/SVGIcons";

export const InsurancePricesElement = ({
  lang,
  setLoading,
  handleAppError,
  isDiscountedPricesPermitted,
}) => {
  const [state, setState] = useState({
    activeCompanyId: null,
    insuranceCompanies: null,
    insurancePrices: null,
    isLoadingPrices: false,
    selectedList: "1",
    left: 0,
  });
  const getInsuranceCompanies = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        "/insurance-companies/get-for-dropdown",
        {
          params: {
            onlyactive: true,
            insurancetype: "health",
          },
        }
      );
      const data = response.data.data;
      const result = [];
      data.forEach((company) => {
        result.push({
          id: company.id,
          title: company.name,
          supports3years: company.supports3years,
        });
      });
      setState({
        ...state,
        activeCompanyId: result.length > 0 ? result[0].id : null,
        supports3years: result.length > 0 ? result[0].supports3years : null,
        insuranceCompanies: result,
      });
    } catch (error) {
      console.log(error.response);
    }
  };
  const getInsurancePrices = async (insuarnceCompanyId) => {
    console.log({ insuarnceCompanyId });
    try {
      setLoading(true);
      let response = null;
      switch (state.selectedList) {
        case "1":
        case "3":
        case "4":
        case "5":
          response = await axios.get("/insurance-prices/get-by-type", {
            params: {
              companyid:
                state.selectedList === "3" || state.selectedList === "4"
                  ? 7
                  : insuarnceCompanyId,
              type:
                state.selectedList === "3" || state.selectedList === "4"
                  ? "Travel"
                  : state.selectedList === "1"
                  ? "Health"
                  : "Tourism",
              fordashboard: true,
            },
          });
          break;
        case "2":
          response = await axios.get(
            "/insurance-prices/get-agency-discounted-prices",
            {
              params: {
                companyid: insuarnceCompanyId,
                type: "Health",
              },
            }
          );
          break;
      }

      // const result = [];
      // response.data.data.forEach((item) => {
      //   for (let i = 0; i < 15; i++) {
      //     result.push(item);
      //   }
      // });
      setState({
        ...state,
        isLoadingPrices: false,
        activeCompanyId: insuarnceCompanyId,
        insurancePrices: response.data.data,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error.response);
    }
  };
  let firstTime = true;
  useEffect(() => {
    getInsuranceCompanies();
    return () => {};
  }, []);
  useEffect(() => {
    if (firstTime && state.activeCompanyId) {
      console.log("changed ...");
      setState({
        ...state,
        isLoadingPrices: true,
      });
      getInsurancePrices(state.activeCompanyId);
    } else {
      firstTime = false;
    }
    return () => {};
  }, [state.activeCompanyId]);
  useEffect(() => {
    if (state.activeCompanyId) {
      getInsurancePrices(state.activeCompanyId);
    }
    return () => {};
  }, [state.selectedList]);
  const slideInsuranceCompanies = (direction = "right") => {
    console.log("clicked slider button ...");
    const companiesSlider = document.getElementById("INSCMP");
    let translate = state.left;
    if (direction === "left") {
      if (translate !== 0) {
        if (lang !== "ar") {
          translate = translate - 250;
        } else {
          translate = translate + 250;
        }
        companiesSlider.scroll({
          left: translate,
          behavior: "smooth",
        });
      }
    } else {
      if (lang !== "ar") {
        translate = translate + 250;
      } else {
        translate = translate - 250;
      }
      companiesSlider.scroll({
        left: translate,
        behavior: "smooth",
      });
    }
    setState({
      ...state,
      left: translate,
    });
  };
  const containerStyle = {
    width: "39%",
    height: "100%",
    backgroundColor: "white",
    paddingLeft: "30px",
    paddingRight: "30px",
  };
  if (lang === "ar") {
    containerStyle.marginLeft = "1%";
  } else {
    containerStyle.marginRight = "1%";
  }
  return (
    <div
      className="col-sm-4 db-element db-insurance-prices-element"
      style={containerStyle}
    >
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ marginTop: "33px" }}
      >
        <select
          className="form-select inter-bold"
          onChange={(e) => {
            setState({
              ...state,
              selectedList: e.target.value,
            });
          }}
          style={{
            width: "25.5rem",
            display: "inline",
            fontSize: "1.25rem",
            border: "none",
          }}
        >
          <option value="1" defaultValue>
            {window.sys_app_translate("Health Insurance Prices", lang)}
          </option>
          {isDiscountedPricesPermitted && (
            <option value="2" defaultValue>
              {window.sys_app_translate(
                "Health Insurance Discounted Prices",
                lang
              )}
            </option>
          )}
          <option value="3" defaultValue>
            {window.sys_app_translate(
              "Travel Insurance Prices - Covid Included",
              lang
            )}
          </option>
          <option value="4" defaultValue>
            {window.sys_app_translate(
              "Travel Insurance Prices - Without Covid",
              lang
            )}
          </option>
          <option value="5" defaultValue>
            {window.sys_app_translate("Tourism Insurance Prices", lang)}
          </option>
        </select>
        {/* <a
          href="#"
          onClick={onClick}
          className="link-item inter-medium clickable"
          style={{ fontSize: "1.06rem" }}
        >
          View all
        </a> */}
      </div>
      {/* Scroll Arrows & Insurance Companies */}
      {state.selectedList !== "3" && state.selectedList !== "4" && (
        <div className="d-flex align-items-center justify-content-around">
          <div
            style={{ cursor: "pointer" }}
            className="cmp-arrow cmp-left-arrow"
            onClick={() => {
              slideInsuranceCompanies("left");
            }}
          >
            {lang !== "ar" && <NavigateLeftButtonIcon />}
            {lang === "ar" && <NavigateRightButtonIcon />}
          </div>
          <div className="ins-cmp" id="INSCMP">
            {state.insuranceCompanies &&
              state.insuranceCompanies.map((insuranceCompany, index) => {
                if (insuranceCompany.id === state.activeCompanyId) {
                  return (
                    <div
                      className="active"
                      key={"els-" + index}
                      style={{
                        minWidth:
                          (insuranceCompany.title.length * 11 + 30) / 16 +
                          "rem",
                      }}
                    >
                      <Button
                        variant="contained"
                        disabled={state.isLoadingPrices}
                        onClick={() => {
                          setState({
                            ...state,
                            activeCompanyId: insuranceCompany.id,
                            supports3years: insuranceCompany.supports3years,
                          });
                        }}
                      >
                        {insuranceCompany.title}
                      </Button>
                    </div>
                  );
                } else {
                  return (
                    <div
                      key={"el-" + index}
                      style={{
                        minWidth:
                          (insuranceCompany.title.length * 11 + 25) / 16 +
                          "rem",
                      }}
                    >
                      <a
                        href="#"
                        className={
                          state.isLoadingPrices
                            ? "btn link-item inter-semi-bold disabled"
                            : "btn link-item inter-semi-bold"
                        }
                        onClick={() => {
                          setState({
                            ...state,
                            activeCompanyId: insuranceCompany.id,
                            supports3years: insuranceCompany.supports3years,
                          });
                        }}
                      >
                        {insuranceCompany.title}
                      </a>
                    </div>
                  );
                }
              })}
          </div>
          <div
            style={{ cursor: "pointer" }}
            className="cmp-arrow cmp-right-arrow"
            onClick={() => {
              slideInsuranceCompanies("right");
            }}
          >
            {lang !== "ar" && <NavigateRightButtonIcon />}
            {lang === "ar" && <NavigateLeftButtonIcon />}
          </div>
        </div>
      )}
      {/* Table Header For Health Insurance Type */}
      {state.selectedList !== "3" &&
        state.selectedList !== "4" &&
        state.selectedList !== "5" && (
          <table className="table prices-table" style={{ paddingLeft: "25px" }}>
            <thead>
              <tr>
                <th className="inter-semi-bold" style={{ width: "100px" }}>
                  {window.sys_app_translate("Ages", lang)}
                </th>
                <th className="inter-semi-bold">
                  {window.sys_app_translate("Price 1st Year", lang)}
                </th>
                <th className="inter-semi-bold">
                  {window.sys_app_translate("Price 2nd Year", lang)}
                </th>
                {state.supports3years === 1 ? (
                  <th className="inter-semi-bold">
                    {window.sys_app_translate("Price 3rd Year", lang)}
                  </th>
                ) : null}
                <th className="inter-semi-bold">
                  {window.sys_app_translate("Total Price", lang)}
                </th>
              </tr>
            </thead>
          </table>
        )}
      {/* Table Header For Travel Insurance Type */}
      {(state.selectedList === "3" || state.selectedList === "4") && (
        <table className="table prices-table" style={{ paddingLeft: "25px" }}>
          <thead>
            <tr>
              <th className="inter-semi-bold" style={{ width: "100px" }}>
                {window.sys_app_translate("Duration", lang)}
              </th>
              <th className="inter-semi-bold">
                {window.sys_app_translate("Europe", lang)}
              </th>
              <th className="inter-semi-bold">
                {window.sys_app_translate("Turkey", lang)}
              </th>
              <th className="inter-semi-bold">
                {window.sys_app_translate("AllOverWorld", lang)}
              </th>
            </tr>
          </thead>
        </table>
      )}
      {state.selectedList === "5" && (
        <table className="table prices-table" style={{ paddingLeft: "25px" }}>
          <thead>
            <tr>
              <th className="inter-semi-bold" style={{ width: "100px" }}>
                {window.sys_app_translate("Plan", lang)}
              </th>
              <th className="inter-semi-bold">
                {window.sys_app_translate("Duration", lang)}
              </th>
              <th className="inter-semi-bold">
                {window.sys_app_translate("Price", lang)}
              </th>
              <th className="inter-semi-bold">
                {window.sys_app_translate("Kum-Dahil", lang)}
              </th>
            </tr>
          </thead>
        </table>
      )}
      {/* Table Body For Health Insurance Type */}
      {state.selectedList !== "3" &&
        state.selectedList !== "4" &&
        state.selectedList !== "5" && (
          <div className="prices-table-container">
            {state.insurancePrices && (
              <table className="table prices-table">
                <tbody style={{ overflowX: "scroll" }}>
                  {state.insurancePrices.map((priceRecord, index) => {
                    return (
                      <tr key={"priceR" + index}>
                        <td
                          className="inter-semi-bold"
                          style={{ width: "100px" }}
                        >
                          {priceRecord.age}
                        </td>
                        <td className="inter-semi-bold">
                          {priceRecord["1year"]}
                        </td>
                        <td className="inter-semi-bold">
                          {priceRecord["2year"]}
                        </td>
                        {state.supports3years === 1 ? (
                          <td className="inter-semi-bold">
                            {priceRecord["3year"]}
                          </td>
                        ) : null}
                        <td className="inter-semi-bold">
                          {priceRecord["total"]}
                        </td>
                      </tr>
                    );
                  })}
                  {state.insurancePrices.length === 0 && (
                    <tr>
                      <td colSpan="100">
                        <span style={{ fontSize: "1rem" }}>
                          {window.sys_app_translate("No prices found!")}
                        </span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        )}
      {state.selectedList === "3" && (
        <div className="prices-table-container">
          {state.insurancePrices && (
            <table className="table prices-table">
              <tbody style={{ overflowX: "scroll" }}>
                {state.insurancePrices.map((priceRecord, index) => {
                  return (
                    <tr key={"priceR" + index}>
                      <td className="inter-semi-bold">
                        {priceRecord.duration}
                      </td>
                      <td className="inter-semi-bold">
                        {priceRecord.europe_c}
                      </td>
                      <td className="inter-semi-bold">
                        {priceRecord.turkey_c}
                      </td>
                      <td className="inter-semi-bold">
                        {priceRecord.alloverworld_c}
                      </td>
                    </tr>
                  );
                })}
                {state.insurancePrices.length === 0 && (
                  <tr>
                    <td colSpan="100">
                      <span style={{ fontSize: "1rem" }}>
                        {window.sys_app_translate("No prices found!")}
                      </span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      )}
      {state.selectedList === "4" && (
        <div className="prices-table-container">
          {state.insurancePrices && (
            <table className="table prices-table">
              <tbody style={{ overflowX: "scroll" }}>
                {state.insurancePrices.map((priceRecord, index) => {
                  console.log(priceRecord);
                  return (
                    <tr key={"priceR" + index}>
                      <td className="inter-semi-bold">
                        {priceRecord.duration}
                      </td>
                      <td className="inter-semi-bold">
                        {priceRecord.europe_wc}
                      </td>
                      <td className="inter-semi-bold">
                        {priceRecord.turkey_wc}
                      </td>
                      <td className="inter-semi-bold">
                        {priceRecord.alloverworld_wc}
                      </td>
                    </tr>
                  );
                })}
                {state.insurancePrices.length === 0 && (
                  <tr>
                    <td colSpan="100">
                      <span style={{ fontSize: "1rem" }}>
                        {window.sys_app_translate("No prices found!")}
                      </span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      )}
      {state.selectedList === "5" && (
        <div className="prices-table-container">
          {state.insurancePrices && (
            <table className="table prices-table">
              <tbody style={{ overflowX: "scroll" }}>
                {state.insurancePrices.map((priceRecord, index) => {
                  return (
                    <tr key={"priceR" + index}>
                      <td
                        className="inter-semi-bold"
                        style={{ width: "100px" }}
                      >
                        {priceRecord["plan"]}
                      </td>
                      <td className="inter-semi-bold">
                        {priceRecord["duration"]}
                      </td>
                      <td className="inter-semi-bold">
                        {priceRecord["price"]}
                      </td>
                      <td className="inter-semi-bold">
                        {priceRecord["iskumdahil"]}
                      </td>
                    </tr>
                  );
                })}
                {state.insurancePrices.length === 0 && (
                  <tr>
                    <td colSpan="100">
                      <span style={{ fontSize: "1rem" }}>
                        {window.sys_app_translate("No prices found!")}
                      </span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
};
